<template>
    <div class="review page">
        <wrapper column background-color="#fff">
            <div class="float image-container">
                <img
                    :src="require(`@/assets/Stage/Review/top.png`)"
                    alt=""
                    width="100%"
                />
                <div class="banner">
                    <div class="text">作答回顧</div>
                </div>
            </div>
            <div class="review-board">
                <component
                    v-for="item in reviewQuestionSet"
                    :key="item.id"
                    :is="type"
                    :data="item"
                />
            </div>

            <BackBtn />

            <div class="float-footer image-container">
                <img
                    :src="require(`@/assets/Stage/Review/footer.png`)"
                    alt=""
                    width="100%"
                />
            </div>
        </wrapper>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import BackBtn from '@/components/Button/BackButton.vue';
import game1 from '@/components/Stage/Review/Game1.vue';
import game2 from '@/components/Stage/Review/Game2.vue';

import PageGeneral from '@/mixins/PageGeneral';
import Status from '@/mixins/Status';

export default {
    mixins: [PageGeneral, Status],
    components: {
        BackBtn,
        game1,
        game2,
    },
    data() {
        return {
            isTowerCollapse: true,
            formPopupState: false,
        };
    },
    computed: {
        ...mapState({
            score: 'score',
            user: 'user',
            reviewQuestionSet: 'reviewQuestionSet',
        }),
        type() {
            return this.$route.params.type;
        },
    },
    created() {
        if (this.score === undefined) this.$router.replace({ name: 'Home' });
    },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";
.review {
    .image-container.float {
        position: relative;
        .banner {
            position: absolute;
            top: 20px;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            .text {
                font-size: 2em;
                font-weight: bold;
                color: #fff;
            }
            .group {
                width: 162px;
                height: 25px;
                font-size: 12px;
                border-radius: 9.4px;
                background-color: #cbebff;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
    .review-board {
        overflow: auto;
        margin-top: -8%;
        z-index: 1;
        width: 90%;
        height: 85%;
        border-radius: 7px;
        background-color: #fff;
        box-shadow: 0 2px 11px 0 rgba(0, 152, 201, 0.37);
    }
}
</style>
